import { useState, useEffect } from 'react';
import { useToast } from '../ToastContext';

const ICONS = { success: '✓', error: '✗', info: 'ℹ' };

function ToastItem({ toast, onDismiss }) {
  const [exiting, setExiting] = useState(false);

  const handleDismiss = () => {
    setExiting(true);
    setTimeout(() => onDismiss(toast.id), 240);
  };

  // Trigger exit animation slightly before context removes the toast
  useEffect(() => {
    if (toast.duration === 0) return;
    const t = setTimeout(() => setExiting(true), (toast.duration || 3000) - 260);
    return () => clearTimeout(t);
  }, [toast.id, toast.duration]);

  return (
    <div className={`toast toast--${toast.type}${exiting ? ' exiting' : ''}`}>
      <span className="toast-icon">{ICONS[toast.type]}</span>
      <span className="toast-msg">{toast.message}</span>
      <button className="toast-dismiss" onClick={handleDismiss} aria-label="Dismiss">✕</button>
    </div>
  );
}

export default function Toast() {
  const { toasts, dismiss } = useToast();
  if (!toasts.length) return null;
  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <ToastItem key={toast.id} toast={toast} onDismiss={dismiss} />
      ))}
    </div>
  );
}
